import Banner from "@/components/Banner";
import {
  EMAIL_IDENTITY_CHECK_DESCRIPTION,
  EMAIL_IDENTITY_CHECK_SUBTEXT,
  emailIdentityCheckRows,
  type EmailIdentityCheckPerson
} from "./emailIdentityCheck";

interface EmailIdentityCheckProps {
  person: EmailIdentityCheckPerson;
}

export default function EmailIdentityCheck({ person }: EmailIdentityCheckProps) {
  const rows = emailIdentityCheckRows(person);

  return (
    <div className="flex flex-col gap-6" data-testid="email-identity-check">
      <Banner
        variant="warn"
        inline
        hideSecondaryDismiss
        description={EMAIL_IDENTITY_CHECK_DESCRIPTION}
        subText={EMAIL_IDENTITY_CHECK_SUBTEXT}
      />
      <dl className="m-0 flex flex-col gap-4">
        {rows.map(({ label, value }) => (
          <div key={label}>
            <dt className="text-label-large text-sys-brand-on-surface-variant">{label}</dt>
            <dd className="mt-0.5 text-title-medium text-sys-brand-on-surface">{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
